import { Navigate, Outlet } from 'react-router-dom';

import { useAppSelector } from '@/store';
import { homeRouteFor, SALES_RM_ROLE } from '@/utils/constants';

// Guards routes accessible to both admin and Sales RM users.
// Assumes it is nested inside ProtectedRoute (user is already authenticated).
const StaffRoute = () => {
  const user = useAppSelector((state) => state.auth.user);
  const allowed = user?.role === 'admin' || user?.jobRole === SALES_RM_ROLE;

  if (!allowed) {
    return <Navigate to={homeRouteFor(user)} replace />;
  }

  return <Outlet />;
};

export default StaffRoute;
